exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-0cbc087e]{padding:20px;height:100%;padding-bottom:0;overflow-y:scroll}.box .tips[data-v-0cbc087e]{font-size:12px;color:#909399;font-size:400}.frame-name .iconfont[data-v-0cbc087e]{padding-right:6px}.icon-h[data-v-0cbc087e]{position:relative}.icon-h>span[data-v-0cbc087e]{color:#1890ff}\n", ""]);

// exports
